export function detectLoading(state) {
    return !!Object.values(state).filter(x => x.loading).length
}
